var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("Header"),
          _c("GameBanner", {
            attrs: {
              src: _vm.gameData.topBgImage,
              variant: _vm.gameData.extraFields.bannerType,
              drawProductId: _vm.gameData.extraFields.bannerDrawProductId,
            },
          }),
          _c("div", { staticClass: "item_welfare" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _c("div", { staticClass: "position" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.welfareList, function (item, index) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "analytics-exposure",
                              rawName: "v-analytics-exposure",
                              value: {
                                event: "activity_exposure",
                                key: item.id,
                                properties: _vm.welfareProperties(item),
                              },
                              expression:
                                "{ event: 'activity_exposure', key: item.id, properties: welfareProperties(item) }",
                            },
                          ],
                          key: item.id,
                          class: [
                            "welfare-card",
                            "welfare-card--" + _vm.getWelfareActionType(item),
                          ],
                        },
                        [
                          item.threshold
                            ? _c("div", { staticClass: "welfare-limit" }, [
                                _vm._v(_vm._s(item.threshold)),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "welfare-icon" }, [
                            _c("img", {
                              staticClass: "first",
                              attrs: { src: item.icon, alt: "" },
                            }),
                          ]),
                          _c("div", { staticClass: "welfare_right" }, [
                            _c("p", { staticClass: "welfare-title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _c("p", {
                              staticClass: "prop",
                              domProps: {
                                innerHTML: _vm._s(_vm.cutout(item.content)),
                              },
                            }),
                            item.amount > 0
                              ? _c(
                                  "div",
                                  { staticClass: "progress-container" },
                                  [
                                    _c("div", { staticClass: "percentage" }, [
                                      _vm._v(_vm._s(item.progressRate) + "%"),
                                    ]),
                                    _c("div", {
                                      staticClass: "progress-bar",
                                      style: "width:" + item.progressRate + "%",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "welfare-action" }, [
                              _vm.getWelfareActionType(item) === "claim"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "receive receive--claim",
                                      attrs: { id: "btn_" + item.id },
                                      on: {
                                        click: function ($event) {
                                          return _vm.receive(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getWelfareActionText(item))
                                      ),
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "receive",
                                      class:
                                        "receive--" +
                                        _vm.getWelfareActionType(item),
                                      attrs: { disabled: "" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getWelfareActionText(item))
                                      ),
                                    ]
                                  ),
                              item.claimed &&
                              _vm.rewardMode == 0 &&
                              item.claimedValue
                                ? _c("div", { staticClass: "package" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.gfitCodeOverlengthOmit(
                                            item.claimedValue
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "clipboard",
                                          rawName: "v-clipboard:success",
                                          value: _vm.onCopySuccess,
                                          expression: "onCopySuccess",
                                          arg: "success",
                                        },
                                        {
                                          name: "clipboard",
                                          rawName: "v-clipboard:copy",
                                          value: item.claimedValue,
                                          expression: "item.claimedValue",
                                          arg: "copy",
                                        },
                                      ],
                                      staticClass: "fa fa-clipboard color",
                                    }),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("p", { staticClass: "h3" }),
                  _c("p", { staticClass: "instructions" }, [_vm._v(" ")]),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
      _c("TipsWindow", { ref: "tips" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }